import { authClient, API } from '../index'

// Get all technologies
export const getAllActiveDevelopmentStates = () => {
    return authClient().get(`${API}/developmentStatus/`)
}

export const getAllDevelopmentStates = () => {
    return authClient().get(`${API}/developmentStatus/?getDisabled=true`)
}

// Get developmentStatus by id
export const getDevelopmentStatusById = (id) => {
    return authClient().get(`${API}/developmentStatus/${id}`)
}

// Create developmentStatus
export const postDevelopmentStatus = async (developmentStatus) => {
    return authClient().post(`${API}/developmentStatus/`, developmentStatus)
}

// Update text
export const updateDevelopmentStatus = (id, developmentStatus) => {
    return authClient().put(`${API}/developmentStatus/${id}`, developmentStatus)
}

// Change status developmentStatus
export const changeStatusDevelopmentStatus = async (id, active) => {
    return authClient().put(`${API}/developmentStatus/change-status/${id}`, { active });
};


// Delete developmentStatus
export const deleteDevelopmentStatus = (id) => {
    return authClient().delete(`${API}/developmentStatus/${id}`)
}
